module.exports = __webpack_public_path__ + "static/assets/0048354f2d2f5a137359716b07da6ddd.png";